import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateLogoRequest } from "../redux/actions/logoActions";
import { getOemPartnerRequest } from "../redux/actions/oemActions";
import {
  MdDashboard,
  MdFolder,
  MdPeople,
  MdAccessTime,
  MdQrCodeScanner,
  MdEdit,
  MdGroup,
  MdReceiptLong,
  MdListAlt,
  MdManageSearch,
} from "react-icons/md";

const Sidebar = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { sidebarCollapsed } = useSelector((state) => state.ui);
  const { user } = useSelector((state) => state.auth);
  const id = user?.oemPartner?.id;
  const { uploading, response } = useSelector((state) => state.logo);
  const { data: oemPartner, loading: oemLoading } = useSelector(
    (state) => state.oem
  );
  const fileInputRef = React.useRef(null);

  React.useEffect(() => {
    if (response?.status === 200) {
      dispatch(getOemPartnerRequest(id));
    }
  }, [response, dispatch, id]);
  React.useEffect(() => {
    if (id && !oemPartner) {
      dispatch(getOemPartnerRequest(id));
    }
  }, [dispatch, id, oemPartner]);

  const logo = oemPartner?.logo;
  const companyName = oemPartner?.companyName || "RR360";
  const oemUrl = oemPartner?.oemUrl;

  const handleLogoEdit = () => {
    fileInputRef.current?.click();
  };

  const handleLogoUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    dispatch(
      updateLogoRequest({
        file,
        _id: oemPartner?._id,
      })
    );
  };

  const scanType = user?.oemPartner?.scanType;
  const menuItems = [
    ...(scanType !== "Multiple"
      ? [{ path: "/dashboard", icon: MdDashboard, label: "Dashboard" }]
      : []),

    ...(scanType === "Multiple"
      ? [{ path: "/scan", icon: MdFolder, label: "Scan"}]
      : []),

    ...(scanType !== "Multiple"
      ? [{ path: "/user", icon: MdGroup, label: "User" }]
      : []),
 
    ...(scanType !== "Multiple" && scanType !== "License"
      ? [
          {
            path: "/plan-transaction",
            icon: MdReceiptLong,
            label: "Transaction",
          },
        ]
      : []),
    ...(scanType !== "Multiple" 
      ? [{ path: "/single-scan", icon: MdQrCodeScanner, label: "Scan Report" }]
      : []),

       ...(scanType !== "Multiple"
      ? [{ path: "/my-domain-scan", icon: MdManageSearch, label: "My Domain Scan" }]
      : []),

    ...(scanType === "Multiple"
      ? [{ path: "/scan-list", icon: MdListAlt, label: "Scan-List" }]
      : []),
  ];

  return (
    <div className={`sidebar ${sidebarCollapsed ? "collapsed" : ""}`}>
      <div className="sidebar-header">
        <div className="logo mt-3">
          {oemLoading ? (
            <div
              style={{
                width: "20px",
                height: "20px",
                border: "3px solid #f3f3f3",
                borderTop: "3px solid #667eea",
                borderRadius: "50%",
                animation: "spin 1s linear infinite",
                margin: "0 auto",
              }}
            ></div>
          ) : (
            <>
              <img
                src={logo}
                alt={`${companyName} Logo`}
                className="sidebar-logo"
                onClick={()=>navigate("/")}
              />
              {!sidebarCollapsed && (
                <button
                  className="logo-edit-btn"
                  title="Change Logo"
                  onClick={handleLogoEdit}
                >
                  <MdEdit />
                </button>
              )}
            </>
          )}
          <input
            type="file"
            ref={fileInputRef}
            onChange={handleLogoUpload}
            accept="image/*"
            style={{ display: "none" }}
          />
        </div>
        <style>
          {`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}
        </style>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          const IconComponent = item.icon;
          return (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-item ${
                location.pathname === item.path ? "active" : ""
              }`}
              data-tooltip={item.label}
              title={sidebarCollapsed ? item.label : ''}
              onMouseEnter={(e) => {
                if (sidebarCollapsed) {
                  const rect = e.currentTarget.getBoundingClientRect();
                  document.documentElement.style.setProperty('--tooltip-top', `${rect.top + rect.height / 2}px`);
                }
              }}
            >
              <span className="nav-icon">
                <IconComponent />
              </span>
              <span className="nav-label">{item.label}</span>
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

export default Sidebar;
